import WebSocket from 'ws';

export function connectToTunnel(tunnelUrl: string): WebSocket {
  const wsUrl = tunnelUrl.replace('https://', 'wss://') + '/term';
  return new WebSocket(wsUrl);
}

export interface AuthMessage {
  type: 'auth';
  idToken: string;
  jti: string;
  buildId: string;
  platform: string;
  userId: string;
  appId: string;
}

export interface AuthAckMessage {
  type: 'auth-ack';
  status: 'ok' | 'error';
  message?: string;
}

export interface StateMessage {
  type: 'state';
  status: string;
  platform: string;
  workingDirectory: string;
  shell: string;
}

export interface ErrorMessage {
  type: 'error';
  message: string;
  fatal: boolean;
}

export interface PongMessage {
  type: 'pong';
  timestamp: number;
}

export interface ResizeMessage {
  type: 'resize';
  cols: number;
  rows: number;
}

export interface PingMessage {
  type: 'ping';
  timestamp: number;
}

export interface CloseMessage {
  type: 'close';
  code?: number;
  reason?: string;
}

export type ControlMessage =
  | AuthAckMessage
  | StateMessage
  | ErrorMessage
  | PongMessage
  | ResizeMessage
  | PingMessage
  | CloseMessage;

export function isControlMessage(data: string): boolean {
  try {
    const parsed = JSON.parse(data);
    return parsed && typeof parsed === 'object' && 'type' in parsed;
  } catch {
    return false;
  }
}

export function parseControlMessage(data: string): ControlMessage {
  return JSON.parse(data) as ControlMessage;
}
